<section class="card">
    <div class="card-header">
        <span class="cat__core__title">
            <strong>DataTables</strong>
        </span>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-lg-12">

                <h5 class="text-black"><strong>Example Table</strong></h5>
                <div class="mb-5">


<!--                    <app-datagrid></app-datagrid>-->


                </div>
            </div>
        </div>
    </div>
</section>
